import React, { FC } from 'react'
import SelectableChipsList, { SelectableChipsListProps, TChipData } from '../../Components/List/SelectableChipsList';
import { Tag } from '../../Models/Tag/@types';

interface SelectableTagsChipsListProps extends Omit<SelectableChipsListProps, 'list' | 'selectedItems' | 'onSelect'> {
    tags: Tag[];
    selectedTags: Tag[];
    onToggle: (tag: Tag) => void;
}

const SelectableTagsChipsList: FC<SelectableTagsChipsListProps> = (props) => {
    const { size, tags, selectedTags, onToggle, ...selectableChipsListProps } = props;
    const chipsList = tags.map((item) => ({ label: item.name, id: item.id, avatar: item._picture?.thumbnailUrl }) as TChipData);
    const selectedChips = selectedTags.map(({ id, name, _picture }) => ({ id, label: name, avatar: _picture?.thumbnailUrl }) as TChipData);

    const onSelect = (item: TChipData) => onToggle(tags.find(x => x.id === item.id)!);

    return (
        <SelectableChipsList list={chipsList} onSelect={onSelect} selectedItems={selectedChips} {...selectableChipsListProps} />
    )
}

export default SelectableTagsChipsList